export const SELL_CAR_DEFAULT_TITLE = '내차판매';
